import Device from '../../../../../../../constants/deviceSizes';

const row = {
  display: 'flex'
};

export default {
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexShrink: 0
  },
  userDataContainer: {
    ...row,
    alignItems: 'center',
    width: '100%',
    [Device.mobile]: {
      flexDirection: 'column',
      alignItems: 'unset'
    }
  },
  field: {
    flexShrink: 0,
    margin: '5px 20px 5px 0px',
    width: '35%',
    [Device.mobile]: {
      width: '100%'
    }
  },
  selectField: {
    flexShrink: 0,
    margin: '5px 20px 5px 0px',
    width: '35%',
    height: 65,
    [Device.mobile]: {
      width: '100%'
    }
  },
  button: {
    flexShrink: 0,
    marginTop: 10,
    [Device.mobile]: {
      width: '100%'
    }
  }
};
